module.exports = __webpack_public_path__ + "static/media/info.22aca6c1.svg";